(ns livefeed.footer.message-status
  (:require
   [livefeed.i18n :refer [translate]]
   [livefeed.icons :as icons]))

(defn component [status best?]
  (let [class-name (str "yle-livefeed__statuses__status__indicator__" (name status) " yle-livefeed__statuses__status__indicator")]
    [:<>
     [:div.yle-livefeed__status
      [:div.yle-livefeed__status__message {:class (when best? :yle-livefeed__status__message--best)}
       (case status
         :moderating (if best?
                       [:<> (translate :status-moderating) (translate :status-moderating-best)]
                       (translate :status-moderating))
         :accepted (translate :status-accepted)
         :rejected (translate :status-rejected)
         :topic-locked (translate :status-topic-locked)
         :connection-error (translate :status-connection-error)
         :connection-closed (translate :status-connection-closed)
         :not-found (translate :status-not-found)
         (translate :status-failed))]]

     (case status
       :moderating
       [:button
        {:class class-name :aria-label (translate :status-moderating)}
        icons/message-status-progress]

       :accepted
       [:button
        {:class class-name :aria-label (translate :status-accepted)}
        icons/message-status-ok]

       :rejected
       [:button
        {:class class-name :aria-label (translate :status-rejected)}
        icons/message-status-rejected]

       (:topic-locked :not-found)
       nil

       [:button
        {:class class-name :aria-label (translate :status-failed)}
        icons/message-status-problem])]))
